






























































import Getters from '@/mixins/Getters'
import { Component, Mixins } from 'vue-property-decorator'

@Component({
  name: 'ImportManual'
})
export default class SendTxData extends Mixins(Getters) {
  // Delete item from list
  protected remove(index: number) {
    this.dataStore.commitTxDataRemove(index)
  }
}
